module.exports = __webpack_public_path__ + "img/logo2.d837cffd.png";